import { DarkGlass } from 'components/DarkGlass'
import Overlay from 'components/Overlay'
import Bg from 'components/Overlay/Bg'
import styled, { css, FlattenSimpleInterpolation, keyframes } from 'styled-components'
import {
  bh,
  lg,
  alertBoxShadow,
  defaultBorderRadius,
  media,
  dialogDangerGlowColor,
  dialogDangerBorder,
  dialogDefaultGlowColor,
  dialogDefaultBorder,
  dialogPrimaryGlowColor,
  dialogPrimaryBorder,
  dialogSecondaryGlowColor,
  dialogSecondaryBorder,
  dialogBg,
} from 'utils/style-utils'

import { DialogVariant } from '../../types'

interface StyleProps {
  variant: DialogVariant
}

const ZoomIn = keyframes`
  0% {
    transform: translate(-10px, 0) scale(0.2);
  }
  100% {
    transform: translate(0, 0) scale(1);
  }
`

const getGlowAnimation = (color: string) => keyframes`
  from {
    box-shadow:
    ${color} 0 0 5rem -2rem,
    ${color} 0 0 0.8rem -0.25rem;
  }
  to {
    box-shadow:
    ${color} 0 0 3rem -1rem,
    ${color} 0 0 0.6rem -0.5rem;
  }
`

const getContainerGlowAnimation = (color: string) => css`
  animation:
    ${getGlowAnimation(color)} 2s infinite alternate,
    0.4s ${ZoomIn} cubic-bezier(0.26, 1.43, 0.65, 1);
`

const containerGlowVariant: Record<DialogVariant, FlattenSimpleInterpolation> = {
  default: getContainerGlowAnimation(dialogDefaultGlowColor),
  primary: getContainerGlowAnimation(dialogPrimaryGlowColor),
  secondary: getContainerGlowAnimation(dialogSecondaryGlowColor),
  danger: getContainerGlowAnimation(dialogDangerGlowColor),
}

const containerBackgroundBorder: Record<DialogVariant, string> = {
  default: dialogDefaultBorder,
  primary: dialogPrimaryBorder,
  secondary: dialogSecondaryBorder,
  danger: dialogDangerBorder,
}

export const StyledContainer = styled.div<StyleProps>`
  z-index: 13;
  position: relative;
  margin: auto;
  min-width: ${bh * 20}px;
  max-width: ${lg}px;
  max-height: 100%;
  transform: translate(0, 0);
  box-shadow: ${alertBoxShadow};
  border-radius: ${defaultBorderRadius};
  padding: 1.2rem 1.5rem;
  overflow-y: auto;

  display: inline-block;
  vertical-align: middle;
  text-align: left;

  ${(props) => containerGlowVariant[props.variant]};

  ${media.sm`
    min-width: auto;
  `}

  ${media.xs`
    width: 100%;
  `}
`
export const StyledContainerBackground = styled(DarkGlass)<StyleProps>`
  border-radius: ${defaultBorderRadius};
  background: ${dialogBg};

  ${(props) => containerBackgroundBorder[props.variant]};
`

export const StyledOverlay = styled(Overlay)`
  padding: 1rem;
  z-index: 11;
`

export const StyledOverlayBackground = styled(Bg)`
  mix-blend-mode: initial;
`
